// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___2Cwxu"};